/**
 * UnknownHostname — visas när app laddas på en hostname som inte finns i
 * `organization_domains`-tabellen.
 *
 * Ref: audit-reports/feat-domain-mapping/rapport.md
 */
import { Loader2 } from "lucide-react";

interface UnknownHostnameProps {
  isLoading?: boolean;
  hostname?: string;
}

export default function UnknownHostname({ isLoading = false, hostname }: UnknownHostnameProps) {
  const shownHostname = hostname ?? (typeof window !== "undefined" ? window.location.hostname : "");

  if (isLoading) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen p-8 text-center">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground mb-4" />
        <p className="text-muted-foreground">Laddar...</p>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center min-h-screen p-8 text-center bg-background">
      <h1 className="text-2xl font-semibold mb-4">Klubb hittades inte</h1>
      <p className="text-muted-foreground mb-2 max-w-md">
        Domänen <code className="bg-muted px-2 py-0.5 rounded text-sm">{shownHostname}</code>{" "}
        är inte kopplad till någon klubb.
      </p>
      <p className="text-muted-foreground mb-6 max-w-md text-sm">
        Om du trodde den skulle fungera, kontrollera URL:en eller kontakta din klubb.
      </p>
      <a
        href="https://boply.app"
        className="text-primary underline text-sm"
        target="_blank"
        rel="noopener noreferrer"
      >
        Läs mer om Boply →
      </a>
    </div>
  );
}
